import React from "react";
import storeIMg from "../../assets/images/store-not-found.png";
import { Image } from "@nextui-org/react";
export default function StoreNotFound() {
  return (
    <React.Fragment>
      <div className="flex-grow flex justify-center items-center  min-h-screen">
        <div>
          <Image src={storeIMg} alt="store-img" />
          <p className="text-base font-normal leading-6 tracking-tight text-center text-[#859BAB;]">
            Oops, it seems like we couldn't find that store!
          </p>
        </div>
      </div>
    </React.Fragment>
  );
}
